import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";

const clean = value => {
  return value.replace(/[\s/]+/g, "");
};

const format = value => {
  let formattedValue = clean(value);
  if (formattedValue.length >= 2) {
    formattedValue = `${formattedValue.substr(0, 2)} / ${formattedValue.substr(
      2
    )}`;
  }
  return formattedValue;
};

const handleChange = (event, callback) => {
  const { value, selectionEnd } = event.target;
  let expDate = clean(event.target.value);
  if (!/^\d*$/.test(expDate)) {
    return;
  }

  // Remove digit from month when space or slash separator is removed
  if (expDate.length === 2 && value.length === 4) {
    expDate = expDate.substr(0, 1);
  }

  // Prefix with 0 if it's the first digit and it is above 1
  if (expDate.length === 1 && parseInt(expDate, 10) > 1) {
    expDate = `0${expDate}`;
  }

  const rightCharsCount = value.length - selectionEnd;
  const formattedValue = format(expDate);
  let newPosition = Math.max(formattedValue.length - rightCharsCount, 0);
  if (formattedValue.length > 8) newPosition += 1;

  // eslint-disable-next-line no-param-reassign
  event.target.value = formattedValue.substr(0, 7);
  callback(event);

  // Update correct cursor position after react re-render
  const input = event.nativeEvent.target;
  setTimeout(() => {
    input.setSelectionRange(newPosition, newPosition);
  }, 0);
};

const ExpDateInput = ({
  showError,
  errorMsg,
  value,
  onBlur,
  onChange,
  withRef,
  ...props
}) => {
  return (
    <TextField
      error={showError}
      helperText={errorMsg}
      value={format(value)}
      onChange={e => handleChange(e, onChange)}
      onBlur={onBlur}
      style={{ width: "66%" }}
      label="Expiration"
      placeholder="MM / YY"
      inputRef={withRef}
      inputProps={{ id: "exp-date" }}
      InputLabelProps={{ shrink: true }}
      {...props}
    />
  );
};

ExpDateInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  showError: PropTypes.bool,
  errorMsg: PropTypes.string,
  withRef: PropTypes.shape({})
};

ExpDateInput.defaultProps = {
  value: "",
  onBlur: () => {},
  showError: false,
  errorMsg: undefined,
  withRef: undefined
};

export default ExpDateInput;
